import { commonService } from './commonService';

export const bookDiscoverySession = {
  ...commonService,
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Discovery Session',
  url: 'https://www.boldare.com/book-a-discovery-session/',
  description:
    'A tailored discovery session with a Boldare Business Solution Architect to help you explore and validate your best product idea. The session delivers a scope proposal, product development timeline, technology recommendations, optional C4 visualizations, and budget estimates for effective planning.',

  serviceOutput: [
    {
      '@type': 'CreativeWork',
      name: 'Scope proposal',
    },
    {
      '@type': 'CreativeWork',
      name: 'Product development timeline',
    },
    {
      '@type': 'CreativeWork',
      name: 'Technology recommendations',
    },
    {
      '@type': 'CreativeWork',
      name: 'Optional C4 visualizations',
    },
    {
      '@type': 'CreativeWork',
      name: 'Budget estimates',
    },
  ],
  audience: {
    '@type': 'Audience',
    description:
      'Companies at various development phases seeking expert guidance on product development planning.',
  },
};
